import { useEffect, useLayoutEffect } from 'react';
import { reportVital } from '@/reportWebVitals';

const navigation = { pathname: '', start: 0, spa: false, sent: false };

export function useNavigationStart(pathname: string): void {
  useLayoutEffect(() => {
    if (navigation.pathname === pathname) return;
    const spa = navigation.pathname !== '';
    Object.assign(navigation, { pathname, spa, sent: false, start: spa ? performance.now() : 0 });
  }, [pathname]);
}

export function useFirstChartMark(painted: boolean): void {
  useEffect(() => {
    if (!painted) return;
    const frame = requestAnimationFrame(() => {
      if (navigation.sent) return;
      navigation.sent = true;
      reportVital(
        'first_chart',
        performance.now() - navigation.start,
        navigation.spa ? 'spa' : undefined
      );
    });
    return () => cancelAnimationFrame(frame);
  }, [painted]);
}
